import { inject } from "@angular/core";
import {
  CanActivateFn,
  Router,
  type GuardResult,
  type MaybeAsync,
} from "@angular/router";
import { AuthManager } from "../services/auth.service";

export const InvalidSessionGuard: CanActivateFn = (
  route,
  state,
): MaybeAsync<GuardResult> => {
  const authService = inject(AuthManager);
  const router = inject(Router);
  if (authService.isAuth()) {
    return router.createUrlTree(["/dashboard"]);
  }
  if (authService.hasStoredToken()) {
    authService.cleanSession();
  }
  return true;
};
